/**
 * Asserts that all given attributes have a value that is not null or undefined.
 *
 * @param attributesObj Object containing the attributes
 */
export const assertAttributes = (attributesObj) => {
    Object.entries(attributesObj).forEach(([attrName, attrValue]) => {
        if (attrValue === undefined || attrValue === null)  {
            throw new Error(`Illegal ${attrName} [${attrValue}]`);
        }
    });
}
